import { useEffect, useRef, useState } from "react"

import { equals } from "ramda"

export const useDeepMemo = <Val,>(cb: () => Val, deps: any[]) => {
  const [value, setValue] = useState<Val>()
  const ref = useRef<any[]>()

  useEffect(() => {
    const prevDeps = ref.current

    if (!prevDeps || deps.some((dep, i) => !equals(dep, prevDeps[i]))) {
      ref.current = deps

      const newValue = cb()

      setValue(newValue)
    }
  }, [deps, cb])


  return value
}